import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useAccessToken } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { Root } from './ProtectByAccessToken.styles'
import { useAuthorization } from '../../containers/AuthorizationProvider/AuthorizationProvider.hooks'

/**
 * The ProtectByAccessToken's component.
 */
const ProtectByAccessToken = props => {
  const { children, fallback, rule } = props
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const accessToken = useAccessToken()
  const { isValid } = useAuthorization()
  const result = rule(isValid)

  useEffect(() => {
    if (!accessToken || !result) {
      return setError(true)
    }
    setLoading(false)
  }, [accessToken])

  if (!error && loading) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  if (error) {
    return fallback()
  }

  return <>{children}</>
}

ProtectByAccessToken.defaultProps = {
  fallback: () => null,
  rule: () => true
}

ProtectByAccessToken.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  rule: PropTypes.func
}

export default ProtectByAccessToken
